import anime from 'animejs';

export function SiteIntro(params) {
	const introLines = document.querySelectorAll('.logo-line');
	const introMark = document.querySelector('.logo-mark');
	const introWrapper = document.querySelector('.intro-wrapper');
	const homeBg = document.querySelector('.home-video');
	const nav = document.querySelector('.nav');
	const header = document.querySelector('.home-content');
	const mainHeading = document.querySelector('.main-heading');

	const timeline = new anime.timeline();

	setTimeout(() => {
		timeline
			.add({
				targets: introLines,
				opacity: {
					value: [ 0, 1 ],
					duration: 200
				},
				strokeDashoffset: [ anime.setDashoffset, 0 ],
				easing: 'easeOutQuad',
				duration: 1000,
				delay: anime.stagger(300)
			})
			.add({
				targets: introMark,
				opacity: [ 0, 1 ],
				duration: 400,
				easing: 'easeOutQuad'
			})
			.add({
				targets: introWrapper,
				opacity: [ 1, 0 ],
				duration: 800,
				easing: 'easeInQuad',
				delay: 1000
			})
			.add({
				targets: header,
				opacity: [ 0, 1 ],
				duration: 800,
				easing: 'easeOutQuad',
				delay: 400
			})
			.add({
				targets: nav,
				opacity: [ 0, 1 ],
				duration: 400,
				easing: 'easeOutQuad',
				complete: () => introWrapper.classList.add('hidden')
			})
			.add({
				targets: mainHeading,
				opacity: [ 1, 1 ],
				delay: 3000,
				duration: 400,
				easing: 'easeOutQuad',
				complete: () => introWrapper.classList.add('hidden')
			});
	}, 600);
}

export function HomeIntro(params) {
	const homeContent = document.querySelector('.home-content');
	const introWrapper = document.querySelector('.intro-wrapper');
	introWrapper.classList.add('hidden');
	const mainHeading = document.querySelector('.main-heading');

	const timeline = new anime.timeline();
	timeline
		.add({
			targets: homeContent,
			opacity: [ 0, 1 ],
			duration: 400,
			easing: 'easeOutQuad'
		})
		.add({
			targets: params.nav,
			opacity: [ 0, 1 ],
			duration: 400,
			easing: 'easeOutQuad'
		});
	// .add({
	// 	targets: mainHeading,
	// 	opacity: [1, 0],
	// 	delay: 3000,
	// 	duration: 400,
	// 	easing: "easeOutQuad"
	// });
}

export function HomeOutro(params) {
	params.homeTransition.classList.remove('hidden');

	const timeline = new anime.timeline();
	timeline.add({
		targets: params.transitionWipe,
		duration: 400,
		width: '100%',
		easing: 'easeInOutQuad'
	});
}

export function DefaultPageIntro(params) {
	const timeline = new anime.timeline();

	timeline
		.add({
			targets: params.contentHeaderBlock,
			opacity: [ 0, 1 ],
			duration: 400,
			easing: 'easeOutQuad'
		})
		.add({
			targets: params.nav,
			opacity: [ 0, 1 ],
			duration: 400,
			easing: 'easeOutQuad'
		})
		.add(
			{
				targets: params.fadeElements,
				opacity: [ 0, 1 ],
				duration: 400,
				easing: 'easeOutQuad'
			},
			'-=200'
		);
}

export function DefaultPageOutro(params) {
	const timeline = new anime.timeline();

	timeline
		.add({
			targets: params.contentHeaderBlock,
			opacity: [ 1, 0 ],
			duration: 200,
			easing: 'easeInQuad'
		})
		.add(
			{
				targets: [ params.content, params.nav, params.fadeElements ],
				opacity: [ 1, 0 ],
				duration: 200,
				easing: 'easeInQuad'
			},
			'-=200'
		);
}

export function CondensedPageOutro(params) {
	const timeline = new anime.timeline();

	timeline.add({
		targets: [ params.content, params.nav ],
		duration: 400,
		easing: 'easeInQuad',
		opacity: [ 1, 0 ]
	});
}

export function CondensedPageIntro(params) {
	const timeline = new anime.timeline();

	timeline.add({
		targets: [ ...params.content, params.nav ],
		duration: 400,
		easing: 'easeOutQuad',
		opacity: [ 0, 1 ]
	});
}

export function BurgerOpen(params) {
	const timeline = new anime.timeline();

	params.burger.classList.remove('hidden');
	params.burgerIcon.classList.add('burger-close-icon');
	params.navLogo.classList.add('burger-copper-logo');

	timeline
		.add({
			targets: params.burgerBg,
			width: '100%',
			// opacity: {
			// 	value: [0, 1],
			// 	duration: 100
			// },
			duration: 400,
			easing: 'easeOutQuad'
		})
		.add({
			targets: params.burgerList,
			opacity: [ 0, 1 ],
			duration: 400,
			easing: 'easeOutQuad'
		});
}

export function BurgerClose(params) {
	const timeline = new anime.timeline();

	params.navLogo.classList.remove('burger-copper-logo');
	params.burgerIcon.classList.remove('burger-close-icon');

	timeline
		.add({
			targets: params.burgerList,
			opacity: [ 1, 0 ],
			duration: 100,
			easing: 'easeInQuad'
		})
		.add({
			targets: params.burgerBg,
			opacity: [ 1, 0 ],
			duration: 100,
			easing: 'easeInQuad',
			complete: () => {
				params.burgerBg.style.opacity = 1;
				params.burgerBg.style.width = '0px';
				params.burger.classList.add('hidden');
			}
		});
}



// WEBPACK FOOTER //
// ./src/anims.js